import AccessControls from "@/components/call/access-controls";
import CallControls from "@/components/call/call-controls";
import AgentParty from "@/components/call/call-header/agent";
import IntercomParty from "@/components/call/call-header/intercom";
import UnknownParty from "@/components/call/call-header/unknown";
import UserParty from "@/components/call/call-header/user";
import Cameras from "@/components/call/cameras";
import Contacts from "@/components/call/contacts";
import NewCall from "@/components/call/new-call";
import Procedures from "@/components/call/procedures";
import { CallDetails, useCallState } from "@EspaceParkQC/sdk-call-center";
import { Empty } from "@EspaceParkQC/sdk-react";
import { Trans } from "react-i18next";
import { Fragment } from "react/jsx-runtime";

export default function Call() {
  const { call } = useCallState();

  // ringing or proceeding calls are "outgoing" calls and should not be displayed right away
  if (!call || call.status === "ringing" || call.status === "proceeding") {
    return (
      <Empty className="h-full mx-auto" style={{ maxWidth: "1600px" }}>
        <p>
          <Trans
            i18nKey="session.online"
            ns="main"
            components={{
              1: <span className="text-primary font-bold" />,
            }}
          />
        </p>
        <NewCall />
      </Empty>
    );
  }

  return (
    <Fragment>
      <div className="grow relative">
        <div className="min-h-screen h-full">
          <CallDetails
            render={({ intercomPartyDetails, agentPartyDetails, userPartyDetails, unknownPartyDetails }) => {
              if (intercomPartyDetails) {
                return (
                  <Fragment>
                    <div className="space-y-6 md:p-6 p-3 pt-0 grow mx-auto" style={{ maxWidth: "1600px" }}>
                      <IntercomParty intercomPartyDetails={intercomPartyDetails} />
                      <div className="flex md:flex-row nowrap flex-col gap-6">
                        <AccessControls intercomPartyDetails={intercomPartyDetails} />
                        <Cameras />
                      </div>
                      <div className="flex md:flex-row flex-col gap-6">
                        <Procedures />
                        <Contacts />
                      </div>
                    </div>
                  </Fragment>
                );
              } else if (agentPartyDetails) {
                return <AgentParty agentPartyDetails={agentPartyDetails} />;
              } else if (userPartyDetails) {
                return <UserParty userPartyDetails={userPartyDetails} />;
              } else if (unknownPartyDetails) {
                return <UnknownParty unknownPartyDetails={unknownPartyDetails} />;
              } else {
                return <Fragment />;
              }
            }}
          />
          <CallControls />
        </div>
      </div>
    </Fragment>
  );
}
